import React from 'react';

import { images } from './pictograms';

interface PictogramImageProps {
  pictogramNature: number;
  pictogramSerialNumber: number;
  serviceSubCategoryCode: string;
  width?: number;
  style?: React.CSSProperties;
  alt?: string;
}

export const PictogramImage: React.FC<PictogramImageProps> = ({
  pictogramNature,
  pictogramSerialNumber,
  serviceSubCategoryCode,
  width = 40,
  style = { margin: '10px 0' },
  alt,
}) => {
  const imageKey = `${serviceSubCategoryCode}-${pictogramNature}-${pictogramSerialNumber}`.replace(
    /-/g,
    '_',
  );
  const imageUrl = images[imageKey];

  if (!imageUrl) {
    return null;
  }

  return (
    <img
      src={imageUrl}
      width={width}
      style={style}
      alt={alt || `Pictogram ${pictogramNature}-${pictogramSerialNumber}`}
    />
  );
};

export default PictogramImage;
